import moment from 'moment';

const isKeyOfEmployeeDirectoryImportSimpleContact = (
  key: string,
): key is keyof EmployeeDirectoryImportSimpleContact => {
  switch (key) {
    case 'firstName':
    case 'nickname':
    case 'lastName':
    case 'email':
    case 'phoneNumber':
    case 'birthdate':
    case 'startDate':
      return true;

    default:
      return false;
  }
};

export const getDiscrepancyKeys = (
  existingData: EmployeeDirectoryImportSimpleContact,
  importedData: EmployeeDirectoryImportSimpleContact,
) => {
  const discrepancies: Array<keyof EmployeeDirectoryImportSimpleContact> = [];
  Object.keys(existingData).forEach((key) => {
    let hasDiscrepancy = false;
    if (
      isKeyOfEmployeeDirectoryImportSimpleContact(key) &&
      existingData[key] &&
      importedData[key]
    ) {
      if (key === 'startDate' || key === 'birthdate') {
        hasDiscrepancy = hasDateDiscrepancy(existingData[key], importedData[key]);
      } else if (existingData[key] && existingData[key] !== importedData[key]) {
        hasDiscrepancy = true;
      }
    }
    if (hasDiscrepancy) {
      discrepancies.push(key as keyof EmployeeDirectoryImportSimpleContact);
    }
  });
  return discrepancies;
};

export const hasDataDiscrepancy = (
  existingData: EmployeeDirectoryImportSimpleContact,
  importedData: EmployeeDirectoryImportSimpleContact,
) => {
  const discrepancyKeys = getDiscrepancyKeys(existingData, importedData);
  return discrepancyKeys.length > 0;
};

const hasDateDiscrepancy = (valueA: string | null, valueB: string | null) =>
  Boolean(valueA && valueB && !moment.utc(valueA).isSame(moment.utc(valueB), 'day'));
